module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAABNElEQVQ4jaXUu0rDYBjG8X8iQlsQF10dFaTg0puwiKOjIMKDulTn6qS4KTrmXXT0AixegF6Aszi5Ka5aFUocmpT0S3PQPJDhO7y/vB85eGEY4sbMloAusArMAe9ADziV9OTu91zEzNaBG6Ce0qEPbEi6zUTMbBF4zADifAIrkp7jCd/Z0C0AABrAYXLCRdYKgDjt5GB0HDNrAB8lEYC6pK8xJIJ+gOkSwLekWjxwj/NQsov75MBFzkoi55mIpB5wWQBcSLrL6wRJ+8Ae8OYsvQK7kg7cmhRiZstAa0IHHtCKXsjxhcQjngKOoiuFJzIAToBjSYMRYmYecA1s5hS7uQK2JYXxHTt/BAC2ojq8IAjmgRegllsyOX1gwQd2/gnA8GOVz/DHUyVtH2hWRJo+MFMRmf0F0tNZ4R05JMsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/images/user_name.png
// module id = 5u64
// module chunks = 3